<template>
    <button
        v-if="interactive"
        type="button"
        class="e3-plus-minus-icon text-white"
        :aria-expanded="expanded ? 'true' : 'false'"
        @click="$emit('click', $event)">
        <MinusIcon v-if="expanded" size="15"/>
        <PlusIcon v-else size="15"/>
    </button>
    <span
        v-else
        class="e3-plus-minus-icon text-white"
        aria-hidden="true">
        <MinusIcon v-if="expanded" size="15"/>
        <PlusIcon v-else size="15"/>
    </span>
</template>

<script>
import MinusIcon from '@/common/components/svg-icons/MinusIcon.vue';
import PlusIcon from '@/common/components/svg-icons/PlusIcon.vue';

export default {
    name: 'PlusMinusButton',
    props: {
        expanded: {
            type: Boolean,
            default: false
        },
        // Native button + aria-expanded. Use only when not nested in another interactive (e.g. ECollapse).
        interactive: {
            type: Boolean,
            default: false
        }
    },
    components: {
        MinusIcon,
        PlusIcon
    }
};
</script>
